

import { Component, Vue } from 'vue-property-decorator';
import AvailableFeatureFlags from './AvailableFlagsSelector.vue';
import CurrentUserFlags from './CurrentUserFlags.vue';
import CurrentUserGroups from './CurrentUserGroups.vue';

@Component({
    components: {
        AvailableFeatureFlags,
        CurrentUserFlags,
        CurrentUserGroups
    }
})
export default class FeatureFlags extends Vue {
}
